export default __webpack_public_path__ + "static/media/bg.4033d7af.jpg";